import { MouseEvent, useState } from "react";

import { Box, CircularProgress, IconButton, Tooltip } from "@mui/material";
import { IoClose } from "react-icons/io5";

import { TCourseDocument } from "../../../../../@types";

export type TCourseDocumentImageProps = {
	file: TCourseDocument;
	onRemoveFile: (id: number) => void;
};

export function CloudCourseDocumentImage({
	file,
	onRemoveFile,
}: TCourseDocumentImageProps) {
	const [isLoading, setIsLoading] = useState(true);

	const onLoad = () => {
		setIsLoading(false);
	};

	const onClickRemoveFile = (
		e: MouseEvent<HTMLButtonElement, globalThis.MouseEvent>,
	) => {
		e.stopPropagation();
		if (file.id) {
			onRemoveFile(file.id);
		}
	};

	return (
		<div className="media-container">
			<img
				src={file.url}
				alt={file.name}
				className="media"
				onLoad={onLoad}
				draggable={false}
			/>
			{isLoading && (
				<Box sx={{ position: "absolute", display: "inline-flex" }}>
					<CircularProgress />
				</Box>
			)}
			<Tooltip title="Remove">
				<IconButton className="remove-button" onClick={onClickRemoveFile}>
					<IoClose />
				</IconButton>
			</Tooltip>
		</div>
	);
}
